// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.PermissionFullReportDashboardAccess.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import Input from 'share/components/controls/Izenda.Input';
import Label from 'share/components/controls/Izenda.Label';
import { get, isNil } from 'lodash/fp';
import actions from '../Izenda.PermissionActions';

@connect(actions)
export default class PermissionFullReportDashboardAccess extends Component {
  static propTypes = {
    permission: React.PropTypes.object.isRequired
  };

  componentWillMount() {
    const {
      permissionStore: { tenantDetail },
      permission
    } = this.props;
    const tenantRoleSetup = get('roleSetup', tenantDetail);
    const isFullReportAndDashboardAccess=get('fullReportAndDashboardAccess',permission);
    if (!isNil(tenantRoleSetup) && !tenantRoleSetup.grantRoleWithFullReportAndDashboardAccess.value && isFullReportAndDashboardAccess) {
      permission.fullReportAndDashboardAccess = false;
    }
  }

  onChange(event) {
    const permission = get('props.permission', this);
    const isChecked = get('target.checked', event);
    permission.updateFullReportAndDashBoardAccess(isChecked);
  };

  /**
   * Check whether we have tenant "Grant Role with Full Report and Dashboard Access" permission. If there is no
   * such permission - disable full access checkbox for current role, otherwise return isTemplatePermissions
   */
  isFullAccessCheckboxDisabled(tenantDetail, isTemplatePermissions) {
    const tenantRoleSetup = get('roleSetup', tenantDetail);
    return !isNil(tenantRoleSetup) && !tenantRoleSetup.grantRoleWithFullReportAndDashboardAccess.value
      ? true
      : isTemplatePermissions;
  }

  render() {
    const {
      permissionStore: { tenantDetail },
      permission,
      localization,
      authorization,
      authorizationConstants: { PERMISSION_KEY: permissionKeys },
      isTemplatePermissions
    } = this.props;

    const isFullAccessCheckboxDisabled = this.isFullAccessCheckboxDisabled(tenantDetail, isTemplatePermissions);
    const hasFullReportAndDashboard = authorization.checkPrivileges([
      permissionKeys.RoleSetupGrantRoleWithFullReportAndDashboardAccessValue
    ]);

    return (
      !permission.isTenantSetup &&
      hasFullReportAndDashboard && (
        <GridLayout className='izenda-GridLayout-Custom'>
          <GridLayout.Row className='u_paddingTop u_paddingBottom'>
            <GridLayout.Col cols={2} className='u_textBold izenda-PermissionCategory-SubCategory'>
              {localization.getText('PERMISSION_LABEL_FULLREPORTDASHBOARDACCESS')}
            </GridLayout.Col>
            <GridLayout.Col cols={9}>
              <Input
                disabled={isFullAccessCheckboxDisabled}
                type='checkbox'
                checked={this.props.getCheckedCommon(permission.fullReportAndDashboardAccess)}
                onChange={this.onChange.bind(this)}
              />
              <Label className='u_marginLeftRight u_paddingRight u_alignMiddle u_textNormal'>
                <span
                  className='icon-info-circled'
                  title={localization.getText('PERMISSION_ICON_TOOLTIP_FULLREPORTDASHBOARDACCESS')}  />
              </Label>
            </GridLayout.Col>
          </GridLayout.Row>
        </GridLayout>
      )
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Settings/PermissionTab/PermissionBody/Izenda.PermissionFullReportDashboardAccess.js